import type { DateRange } from 'react-day-picker';

export default function isSelectedDateEmpty(selected: DateRange | undefined): boolean {
  return selected === undefined || (selected?.from === undefined && selected?.to === undefined);
}
